import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import env from "src/env"
import { PLANNER_TAG } from "src/configuration"
import { selectToken } from "src/engine/modules/session/selectors"
import { TemplateForm, Templates } from "src/components/ReportGeneratorWidget"

const {
  REACT_APP_REPORT_SERVICE_URL,
  REACT_APP_FILES_STORAGE_URL,
  REACT_APP_SECURITY_SERVICE,
} = env

const NEW_ID = `new`

const ReportTemplates = props => {
  const {
    match: {
      params: { id },
    },
    history: { push, goBack },
    location: { pathname },
    token,
  } = props

  const goto = where => push({ pathname: `${pathname}/${where}` })
  const getToken = () => token

  if (id) {
    return (
      <TemplateForm
        templateCode={id === NEW_ID ? undefined : id}
        onDeleted={goBack}
        onCanceled={goBack}
        getToken={getToken}
        reportServiceUrl={REACT_APP_REPORT_SERVICE_URL}
        filesServiceUrl={REACT_APP_FILES_STORAGE_URL}
        securityServiceURL={REACT_APP_SECURITY_SERVICE}
        requiredTags={[PLANNER_TAG]}
      />
    )
  }

  return (
    <Templates
      onCreate={() => goto(NEW_ID)}
      onEdit={goto}
      getToken={getToken}
      reportServiceUrl={REACT_APP_REPORT_SERVICE_URL}
      filesServiceUrl={REACT_APP_FILES_STORAGE_URL}
      securityServiceURL={REACT_APP_SECURITY_SERVICE}
      requiredTags={[PLANNER_TAG]}
    />
  )
}

ReportTemplates.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  token: PropTypes.string.isRequired,
}

export default connect(state => ({ token: selectToken(state) }))(
  ReportTemplates,
)
